<template>
    <mobile v-if="gl.isMobile" class="mt-4" />
    <desktop v-else />
</template>
  
<script>
// store
import { useGl } from '@store/ts/gl';

// components
import Desktop from './desktop.vue';
import Mobile from './mobile.vue';
  
export default {
    name: 'trade-statistic-view',
    components: {
        Mobile,
        Desktop,
    },
    setup() {
        // store
        const gl = useGl();
      
        return {
            gl,
        };
    },
};
</script>